import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import './SimplePage.css';

export default function NotFoundPage() {
  return (
    <div className="simple-page">
      <SEO
        title="Page Not Found — Zepliq"
        description="The page you are looking for does not exist or has been moved."
        canonical="/404"
        noIndex={true}
      />

      <section className="simple-hero simple-hero--sm">
        <div className="simple-hero__blob simple-hero__blob--1" aria-hidden="true" />
        <div className="simple-hero__blob simple-hero__blob--2" aria-hidden="true" />
        <div className="container simple-hero__inner">
          <span className="badge badge-brand">404</span>
          <h1 className="display-xl simple-hero__title">Page not found</h1>
          <p className="text-lg simple-hero__sub">
            The page you are looking for does not exist or has been moved.
          </p>
          <div className="simple-cta-actions">
            <Link to="/" className="btn btn-primary btn-lg">Back to Home</Link>
            <Link to="/blog" className="btn btn-ghost btn-lg">Read the Blog</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
